import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider, useSelector } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";

// ⬇️ IMPORT SESSION MANAGER
import { startSessionWatcher, stopSessionWatcher } from "./utils/sessionManager";

// ⬇️ THIS COMPONENT WATCHES LOGIN STATUS
function SessionHandler() {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);

  React.useEffect(() => {
    if (isLoggedIn) {
      // Start 5 min inactivity tracking
      startSessionWatcher();
    } else {
      // Stop tracking on logout
      stopSessionWatcher();
    }
  }, [isLoggedIn]);

  return null;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        {/* 👇 Auto session timeout watcher */}
        <SessionHandler />

        <App />
      </HelmetProvider>
    </Provider>

    <ToastContainer />
  </React.StrictMode>
);

reportWebVitals();
